import React from 'react';
import { useNavigate } from 'react-router-dom';

export const AI_CHAT_EXPERIMENT_ACK_KEY = 'kivo.aiChatExperimentalAccepted';

export default function AssistantExperimentalGatePage(): React.JSX.Element {
  const navigate = useNavigate();

  const proceed = () => {
    window.sessionStorage.setItem(AI_CHAT_EXPERIMENT_ACK_KEY, '1');
    navigate('/assistant/chat', { replace: true });
  };

  return (
    <div className="kv-exp-gate">
      <section className="kv-exp-gate__panel" aria-labelledby="assistant-experiment-title">
        <div className="kv-exp-gate__mark" aria-hidden="true">
          <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9">
            <path d="M12 9v4" strokeLinecap="round" />
            <path d="M12 17h.01" strokeLinecap="round" />
            <path
              d="M10.3 3.7 2.4 17.2A2 2 0 0 0 4.1 20h15.8a2 2 0 0 0 1.7-2.8L13.7 3.7a2 2 0 0 0-3.4 0Z"
              strokeLinejoin="round"
            />
          </svg>
        </div>

        <p className="kv-exp-gate__eyebrow">Pre-alpha test</p>
        <h1 id="assistant-experiment-title" className="kv-exp-gate__title">
          Kivo AI chat is purely experimental.
        </h1>
        <p className="kv-exp-gate__body">
          This feature is in pre-alpha and is available for testing purposes only. Responses may be incomplete,
          incorrect, slow, or unstable, and they should not be treated as medical advice or a reliable skincare plan.
        </p>
        <p className="kv-exp-gate__body">
          Continue only if you understand that you are testing an early experimental assistant.
        </p>

        <div className="kv-exp-gate__actions">
          <button type="button" className="kv-exp-gate__primary" onClick={proceed}>
            I understand, proceed to AI chat
          </button>
          <button type="button" className="kv-exp-gate__secondary" onClick={() => { navigate('/'); }}>
            Go back
          </button>
        </div>
      </section>
    </div>
  );
}
